import { SupportedMessageNodes } from "../../../../models/generated/graphql";
import CaseMessagesRoot from "../../messages/CaseMessagesRoot";

interface IProps {
	caseId: string;
}

export const Chats = (props: IProps) => {
	const { caseId } = props;
	return <CaseMessagesRoot nodeId={caseId} nodeLabel={SupportedMessageNodes.Case} showInput={true} deleteMessageCondition={true} />;
};
